import { Icon, Button as MuiButton } from '@material-ui/core';
import { getTheme, pxToRem } from '~/utils';
import { styled } from '~/utils/modules';

// Cores e espaçamentos
const primaryDark = getTheme('primary.dark');
const primaryMain = getTheme('primary.main');
const smallSpacing = getTheme('smallSpacing');
const inMobile = getTheme('inMobile');

export const Content = styled.div`
  flex: 1;
  width: 100%;
  background-color: ${primaryMain};
  flex-direction: column;
`;

export const Childrens = styled.div`
  flex-direction: column;
  padding: ${smallSpacing};
`;

export const SectionTitle = styled.div`
  flex-direction: row;
  align-items: center;
  margin-bottom: ${smallSpacing};
  justify-content: space-between;
`;

export const Title = styled.h5`
  margin: 0;
  color: ${primaryDark};
  font-size: ${pxToRem(25)};
  margin-left: ${smallSpacing};
  

  @media ${inMobile} {
    font-size: ${pxToRem(20)};
  }
`;

export const IconStyled = styled(Icon)`
  color: ${primaryDark};
  cursor: pointer;
  
`;

export const WrapperContent = styled.div`
  padding: ${smallSpacing};
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
  display: flex;
  flex-direction: column;
  align-items: flex-start; 
  width: 100%;
  margin-bottom: ${smallSpacing};
`;

export const InputStyled = styled.input`
  margin-bottom: ${smallSpacing};
  padding: 10px;
  border: 1px solid #ccc;
  border-radius: 4px;
  width: 100%;
  max-width: 300px;
`;

export const ButtonStyled = styled(MuiButton)`
  margin-top: ${smallSpacing};
  background-color: ${primaryDark};
  color: white;
  &:hover {
    background-color: ${primaryDark};
  }
`;
